import React from 'react';

type Props = {
  content?: any;
};

export default function ProgramAbout({ content }: Props) {
  const aboutText = content?.about || content?.description || '';

  if (!aboutText) return null;

  const paragraphs = aboutText
    .split('\n')
    .map((paragraph: string) => paragraph.trim())
    .filter(Boolean);

  if (!paragraphs.length) return null;

  return (
    <section className="program-view__about">
      <h2 className="program-view__asideTitle">Sobre o programa</h2>

      <div className="program-view__aboutText">
        {paragraphs.map((paragraph: string, index: number) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
